import React from 'react';
import { 
  Home, Calendar, Users, Utensils, Dumbbell, ShoppingBag, Moon, Brain
} from 'lucide-react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useProfileStore } from '../store/profileStore';

export function BottomNav() {
  const location = useLocation();
  const navigate = useNavigate();
  const { hormoneType, isNerdMode } = useProfileStore();
  const currentPath = location.pathname;

  const tabs = [
    {
      id: 'home',
      label: 'Home',
      icon: <Home className="w-4 h-4" />,
      path: '/home'
    },
    {
      id: 'workouts',
      label: 'Workouts',
      icon: <Dumbbell className="w-4 h-4" />,
      path: '/workouts'
    },
    {
      id: 'mindfulness',
      label: 'Mindfulness',
      icon: <Brain className="w-4 h-4" />,
      path: '/mindfulness'
    },
    {
      id: 'plan',
      label: 'Plan',
      icon: <Calendar className="w-4 h-4" />,
      path: '/plan'
    }
  ];

  // Add cycle tab after workouts only for estrogen profile
  if (hormoneType === 'estrogen') {
    tabs.push({
      id: 'cycle',
      label: 'Cycle',
      icon: <Moon className="w-4 h-4" />,
      path: '/cycle'
    });
  }

  // Add remaining tabs only in nerd mode
  if (isNerdMode) {
    tabs.push(
      {
        id: 'club',
        label: 'Club',
        icon: <Users className="w-4 h-4" />,
        path: '/club'
      },
      {
        id: 'nutrition',
        label: 'Nutrition',
        icon: <Utensils className="w-4 h-4" />,
        path: '/nutrition'
      },
      {
        id: 'shop',
        label: 'Shop',
        icon: <ShoppingBag className="w-4 h-4" />,
        path: '/shop'
      }
    );
  }

  return (
    <nav className="fixed bottom-0 left-0 right-0 bg-background/80 backdrop-blur-lg border-t border-border z-50 h-14">
      <div className="container mx-auto px-4 h-full">
        <div className="flex w-full h-full">
          {tabs.map((tab) => {
            const isActive = currentPath === tab.path;
            return (
              <button
                key={tab.id}
                onClick={() => navigate(tab.path)}
                className="flex-1 flex flex-col items-center justify-center relative group"
              >
                <div className="relative">
                  <div className={`transition-colors ${
                    isActive ? 'text-primary' : 'text-muted-foreground'
                  }`}>
                    {tab.icon}
                  </div>
                  {isActive && (
                    <div className="absolute inset-0 bg-primary/20 blur-xl rounded-full" />
                  )}
                </div>
                <span className={`text-[10px] mt-0.5 transition-colors ${
                  isActive ? 'text-primary' : 'text-muted-foreground'
                }`}>
                  {tab.label}
                </span>
                {isActive && (
                  <div className="absolute -bottom-[1px] left-1/2 w-8 h-0.5 bg-primary -translate-x-1/2 rounded-full">
                    <div className="absolute inset-0 bg-primary/50 blur-sm" />
                  </div>
                )}
              </button>
            );
          })}
        </div>
      </div>
    </nav>
  );
}